import {XRayUIDao} from '../xray-ui_dao';

export class XrayNameValidatorDao extends XRayUIDao {

    constructor($resource, XRAY_RESOURCE, xrayUINotificationsInterceptor) {
        super($resource, XRAY_RESOURCE, xrayUINotificationsInterceptor);

        this.setUrl(XRAY_RESOURCE.API_URL + XRAY_RESOURCE.NAME_VALIDATOR);
        this.setCustomActions({
            get: {
                'params': {
                    name: '@name'
                }
            },
            'validatePolicyName': {
                method: 'GET',
                params: {name: '@name'},
                path: '/policies/validate/:name'
            }
        });
    }
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/name_validator_dao.js